import { type ComponentPropsWithoutRef } from 'react';
import { t } from '../../i18n';

const sizeMap = {
  sm: 'w-3 h-3',
  md: 'w-4 h-4',
  lg: 'w-5 h-5',
} as const;

export type SpinnerSize = keyof typeof sizeMap;

export interface SpinnerProps extends Omit<ComponentPropsWithoutRef<'svg'>, 'children'> {
  /** @default 'md' */
  size?: SpinnerSize;
}

export function Spinner({ size = 'md', className = '', ...rest }: SpinnerProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      className={`animate-spin ${sizeMap[size]} ${className}`}
      role="status"
      aria-label={t('spinner.ariaLabel')}
      {...rest}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="3"
        strokeOpacity="0.25"
      />
      <path
        d="M12 2a10 10 0 0 1 10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
